import { Injectable } from '@angular/core';
import { ExcutiveurlService } from './excutiveurl.service';
import { HttpServiceService } from 'src/app/common-service/http-service.service';
import { encryptionService } from 'src/app/common-service/cedService';
import { ServerURLService } from 'src/app/common-service/serverURL.service';

@Injectable({
  providedIn: 'root'
})
export class ExcutiveService {


  constructor(public url: ExcutiveurlService, public http: HttpServiceService, public ced: encryptionService, public serverURL: ServerURLService) { }
  // Dashboard
  dashboard() {
    return this.http.get(this.url.Dashboard);

  }
  // Upcoming Meetings
  upcomingMeetings() {
    return this.http.get(this.url.upcomingMeetings);
  }
  // Upcoming Meetings
  sectionList() {
    return this.http.get(this.url.AllSection);
  }
  // Previous Meetings
  previousMeetings(meetingId: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.previousMeetings + '?meetingIdEncr=' + meetingIdEncr);
  }
  // Previous Meetings Vote Of thnaks is not nulll
  previousMeetingsVoteOfThanksIsNotNull(meetingId: any) {
    return this.http.get(this.url.previousMeetingsVoteOfThanksIsNotNull + '?meetingId=' + meetingId);
  }
  // Get Agenda List By Meeting Menu Meetings
  getAgendaListByMeetings(meetingId: any, meetingList: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    const meetingListIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingList, this.serverURL.secretKey).toString());
    return this.http.get(this.url.AllAgendaByMeeting + '?meetingIdEncr=' + meetingIdEncr + '&meetingListIdEncr=' + meetingListIdEncr);
  }

  getAllAgendaList(meetingId: any, sectionId: any) {
    // if (sessionStorage.getItem('selectedRole-usec') === 'Secretary' || sessionStorage.getItem('selectedRole-usec') === 'President') {
    //   return this.http.get(this.url.getSectionList + '?meetingId=' + meetingId + '&sectionId=' + sectionId);
    // } else {
    //   return this.http.get(this.url.getSectionList + '?meetingId=' + meetingId + '&userId='
    //     + JSON.parse(sessionStorage.getItem('userInfo-usec'))['userId'] + '&sectionId=' + sectionId);
    // }
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getSectionList + '?meetingIdEncr=' + meetingIdEncr + '&sectionId=' + sectionId);
  }
  // getSectionMeetingListView(meetingId: any, sectionId: any) {
  //   if (sessionStorage.getItem('selectedRole-usec') === 'Secretary' || sessionStorage.getItem('selectedRole-usec') === 'President') {
  //     const obj = {
  //       meetingIdEncr: this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString(),
  //       sectionIdEncr: ''
  //     }
  //     return this.http.post(this.url.getSectionMeetingListView, obj);
  //   } else {
  //     const obj = {
  //       meetingIdEncr: this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString(),
  //       sectionIdEncr: this.ced.encryptAesToString(sectionId, this.serverURL.secretKey).toString()
  //     }
  //     return this.http.post(this.url.getSectionMeetingListView, obj);
  //   }
  // }

  getSectionMeetingListView(meetingId: any, sectionId: any) {
    const obj = {
      meetingIdEncr: this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString(),
      sectionId: sectionId
    }
    return this.http.post(this.url.getSectionMeetingListView, obj);
  }

  getAgendaListByMeetingId(meetingId: any, meetingListId: any, page: number, rowId: number) {
    return this.http.get(this.url.getAgendaListByMeeting + '?meetingId=' + meetingId + '&meetingListId=' + meetingListId + '&page=' + page + '&rows=' + rowId)
  }

  AllMeetingHistory(date: any) {
    if (sessionStorage.getItem('selectedRole-usec') === 'Executive Committee') {
      return this.http.get(this.url.meetingHistory + '?date=' + date);
    } else if (sessionStorage.getItem('selectedRole-usec') === 'Secretary' || sessionStorage.getItem('selectedRole-usec') === 'Secretary Incharge' || sessionStorage.getItem('selectedRole-usec') === 'President') {
      if (date !== '') {
        return this.http.get(this.url.meetingHistoryAfterCurrDate + '?date=' + date);
      } else {
        return this.http.get(this.url.meetingHistoryAfterCurrDate);
      }
    }
  }

  AllReviewListSecretary(date: any) {
    return this.http.get(this.url.meetingHistoryBeforeStartMeeting + '?date=' + date);
  }

  AllCompletedMeetingHistory(date: any) {
    if (sessionStorage.getItem('selectedRole-usec') === 'Executive Committee') {
      return this.http.get(this.url.meetingHistory + '?date=' + date);
    } else {
      return this.http.get(this.url.AllCompletedMeetingHistory + '?sectionHeadUserId=' +
        JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&date=' + date);
    }
  }


  AllCompletedMeetingBySection(date: any) {
    const obj = {
      date: date,
      sectionIdEncr: this.ced.encryptAesToString(JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId, this.serverURL.secretKey).toString()
    }
    return this.http.post(this.url.AllCompletedMeetingBySection, obj);
  }

  //Getting meeting upto current date
  AllMeetingHistoryUptoCurrentdate(date: any) {
    if (sessionStorage.getItem('selectedRole-usec') === 'Executive Committee') {
      return this.http.get(this.url.meetingHistoryuptocurrentdate + '?date=' + date);
    } else {
      return this.http.get(this.url.shDashboard + '?sectionHeadUserId=' +
        JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&date=' + date);
    }
  }

  //Getting meeting upto current date Minutes Published
  AllMeetingHistoryUptoCurrentdateMOMPublished(date: any) {
    if (sessionStorage.getItem('selectedRole-usec') === 'Executive Committee') {
      return this.http.get(this.url.meetingHistoryuptocurrentdatemompublished + '?date=' + date);
    } else {
      return this.http.get(this.url.shDashboard + '?sectionHeadUserId=' +
        JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&date=' + date);
    }
  }

  // Section Head Agenda List
  getAgendaList(meetingId: any, page: number, rowId: number) {
    return this.http.get(this.url.shAgendaList + '?sectionHeadUserId=' +
      JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&meetingId=' + meetingId + '&page=' + page + '&rows=' + rowId);
  }

  getAgendaListBySectionId(meetingId: any, page: number, rowId: number) {
    return this.http.get(this.url.getAgendaListBySectionId + '?sectionHeadUserId=' +
      JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&meetingId=' + meetingId + '&sectionId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId + '&page=' + page + '&rows=' + rowId);
  }

  getAgendaListByMeeting(meetingId: any, page: number, rowId: number) {
    return this.http.get(this.url.getAgendaListByMeetingId + '?sectionHeadUserId=' +
      JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&meetingId=' + meetingId + '&sectionId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId + '&page=' + page + '&rows=' + rowId);
  }

  getAgendaListByAll(meetingId: any, page: number, rowId: number) {
    return this.http.get(this.url.getAgendaListAll + '?sectionHeadUserId=' +
      JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&meetingId=' + meetingId + '&page=' + page + '&rows=' + rowId);
  }

  // Meeting venues List
  getMeetingVenueList(meetingId: any, date: any) {
    if (date !== '') {
      return this.http.get(this.url.venuesMeetingList + '?meetingId=' + meetingId + '&date=' + date);
    } else {
      return this.http.get(this.url.venuesMeetingList + '?meetingId=' + meetingId);
    }
  }

  getMeetingVenueListNew(date: any) {
    if (date !== '') {
      return this.http.get(this.url.venuesMeetingListNew + '&date=' + date);
    } else {
      return this.http.get(this.url.venuesMeetingListNew);
    }
  }

  meetingDetails(meetingId: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.meetingDetails + '?meetingIdEncr=' + meetingIdEncr);
  }
  // View Agenda
  getAgenda(agendaId: any) {
    const agendaIdEncr = encodeURIComponent(this.ced.encryptAesToString(agendaId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.viewAgenda + '?agendaIdEncr=' + agendaIdEncr);
  }

  // Minutes Status Update
  momStatus(agendaId: any) {
    return this.http.get(this.url.momStatus + '?agendaId=' + agendaId);
  }

  // Agenda Item Number
  agendaItemNumber(agendaItem: any, meetingId: any) {
    return this.http.get(this.url.agendaItem + '?agendaItemNumber' + agendaItem + '&meetingId=' + meetingId);
  }
  // Agenda Item List
  basedAgendaList(meetingId: any, meetingListId: any, page: number, rows: number) {
    return this.http.get(this.url.agendaList + '?meetingId=' + meetingId + '&meetingListId=' + meetingListId + '&page=' + page + '&rows=' + rows);
  }
  // Agenda Item List
  basedAgendaListCMM(meetingId: any, page: number, rows: number) {
    return this.http.get(this.url.agendaListCMM + '?meetingId=' + meetingId + '&page=' + page + '&rows=' + rows);
  }

  basedAgendaviewListCMM(meetingId: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.basedAgendaviewListCMM + '?meetingIdEncr=' + meetingIdEncr);
  }
  checkAllConfirmMinutes(meetingId: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.checkAllConfirmMinutes + '?meetingIdEncr=' + meetingIdEncr);
  }
  // Agenda Item List
  meetingVenueList() {
    return this.http.get(this.url.meetingVenueList);
  }
  meetingDates(meetingId: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.meetingDates + '?meetingIdEncr=' + meetingIdEncr);
  }
  meetingDatesUptoCurr() {
    return this.http.get(this.url.meetingDatesUptoCurr);
  }
  getAgendaSectionList() {
    return this.http.get(this.url.agendaSectionList);
  }
  signedDownload(meetingId: any) {
    return this.http.get(this.url.downloadSignedMinutes + '?meetingId=' + meetingId);
  }
  // Inspection Shedulers
  States() {
    return this.http.get(this.url.States);
  }
  getCityState(id: any) {
    return this.http.get(this.url.cityByStates + '?stateName=' + id);
  }
  getAgendaItem(agendaItem: any, meetingId: any) {
    return this.http.get(this.url.agendaItemView + '?agendaItemNumber=' + agendaItem + '&meetingId=' + meetingId);
  }
  getCaseItem(id: any) {
    return this.http.get(this.url.caseItem + '?agendaId=' + id);
  }
  getListReview(date: any) {
    if (date !== '') {
      return this.http.get(this.url.getListReview + '?roleName=' + sessionStorage.getItem('selectedRole-usec') + '?date=' + date);
    } else {
      return this.http.get(this.url.getListReview + '?roleName=' + sessionStorage.getItem('selectedRole-usec'));
    }
  }
  agendaContent(agendaKeyword: any, data: any, meetingId: any) {
    return this.http.get(this.url.searchAgendaContent + '?agendaKeyword=' + agendaKeyword + '&inSubject='
      + data.inSubject + '&inMatter=' + data.inMatter + '&inDiscusions=' + data.inDiscusions + '&inDecision='
      + data.inDecision + '&meetingId=' + meetingId);
  }
  agendaContentWithoutMeeting(agendaKeyword: any, data: any) {
    return this.http.get(this.url.searchAgendaContent + '?agendaKeyword=' + agendaKeyword + '&inSubject='
      + data.inSubject + '&inMatter=' + data.inMatter + '&inDiscusions=' + data.inDiscusions + '&inDecision='
      + data.inDecision);
  }
  // Add New Meeting
  // Post calls
  addMeeting(meetingId: any, data: any) {
    return this.http.post(this.url.addMeeting + '?meetingId=' + meetingId, data);
  }
  addMeetingNew(data: any) {
    return this.http.post(this.url.addMeetingNew, data);
  }
  addVenueMeeting(data: any) {
    return this.http.post(this.url.addVenueMeeting, data);
  }

  updateMeeting(data: any) {
    return this.http.post(this.url.updateMeetings + '?sectionHeadUserId=' +
      JSON.parse(sessionStorage.getItem('userInfo-usec')).userId, data);
  }

  updateEcmMembers(data: any) {
    return this.http.post(this.url.updateEcmMembers, data);
  }

  voteOfThanks(data: any) {
    if (sessionStorage.getItem('selectedRole-usec') === 'Executive Committee') {
      return this.http.post(this.url.updateMeetings + '?sectionHeadUserId=' +
        JSON.parse(sessionStorage.getItem('userInfo-usec')).userId, data);
    } else {
      return this.http.post(this.url.voteOfThanksNotes + '?roleName=' + sessionStorage.getItem('selectedRole-usec'), data);
    }
  }
  updateMomStatus(data: any) {
    if (sessionStorage.getItem('selectedRole-usec') === 'Executive Committee') {
      return this.http.post(this.url.updateMomStatus, data);
    }
  }
  updateVenue(data: any) {
    return this.http.post(this.url.updateVenueDetails, data);
  }
  confirmAgenda(data: any) {
    return this.http.post(this.url.confirmAgenda, data);
  }

  //below 2 service for section master 
  getAllSectionsAndDisplayFlag() {
    return this.http.get(this.url.getAllSectionsAndDisplayFlag);
  }
  getSubSectionBySectionId(sectionId: any) {
    const sectionIdEncr = encodeURIComponent(this.ced.encryptAesToString(sectionId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getSubSectionBySectionId + '?sectionIdEncr=' + sectionIdEncr)
  }

  //below 2 service for Agenda section master 
  getEcAgendaSectionList() {
    return this.http.get(this.url.getAgendaSectionList);
  }
  getSubSectionByAgendaSectionId(sectionId: any) {
    const sectionIdEncr = encodeURIComponent(this.ced.encryptAesToString(sectionId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getSubSectionByAgendaSectionId + '?sectionIdEncr=' + sectionIdEncr);
  }

  confirmAgendaAOB(data: any) {
    return this.http.post(this.url.confirmAgendaAOB, data);
  }
  sendToEC(fileArray: any, obj: any) {
    const formData = new FormData();
    formData.append('ecMailDtoStr', JSON.stringify(obj));
    formData.append('file', fileArray[0]);

    return this.http.post(this.url.sendTOEc, formData);
  }

  finalMomPublish(meetingId: any, fileArray: any) {
    const formData = new FormData();
    formData.append('file', fileArray[0]);
    return this.http.post(this.url.finalMomPublish + '?meetingId=' + meetingId + '&userId=' +
      JSON.parse(sessionStorage.getItem('userInfo-usec')).userId, formData);

  }

  // Update Calls
  // Update Agenda
  saveAgenda(data: any) {
    return this.http.update(this.url.saveAgenda, data);
  }
  saveSHAgenda(data: any) {
    return this.http.update(this.url.saveSHAgenda, data);
  }
  saveSHAgendaRefinement(data: any) {
    return this.http.update(this.url.saveSHAgendaRefinement, data);
  }
  differAgenda(data: any) {
    return this.http.update(this.url.differAgenda, data);
  }
  updateAgenda(data: any) {
    return this.http.update(this.url.updateAgenda, data);
  }
  DecideAgenda(data: any) {
    return this.http.update(this.url.decideAgenda, data);
  }
  momPublish(meetingId: any) {
    return this.http.post(this.url.momPublish + '?meetingId=' + meetingId, '');
  }
  sendReview(id: any) {
    return this.http.update(this.url.sendReview + '?meetingId=' + id, '');
  }
  // Send Section Head Review
  sendSHReview(meetingId: any) {
    return this.http.update(this.url.shReview + '?meetingId=' + meetingId + '&userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec'))['userId'], '');
  }
  // Finalize Meetings
  finalizeMeeting(data: any, meetingId: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    if (data === 'finalize') {
      return this.http.update(this.url.finalizeMeeting + '?meetingIdEncr=' + meetingIdEncr, '');
    } else {
      return this.http.update(this.url.finalizedSupplementary + '?meetingIdEncr=' + meetingIdEncr, '');
    }
  }
  // Finish Refinement
  finishRefinements(id: any) {
    return this.http.update(this.url.finishRefinements + '?meetingId=' + id + '&userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec'))['userId'], '');
  }

  //EC Member List
  getECMemberList() {
    return this.http.get(this.url.getECMemberList);
  }

  // Agenda Item List
  viewECMemberList(meetingId: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getAttendeesECMember + '?meetingIdEncr=' + meetingIdEncr);
  }

  removeMeetingwithAgenda(data: any) {
    const agendaIdEncr = encodeURIComponent(this.ced.encryptAesToString(data, this.serverURL.secretKey).toString());
    return this.http.get(this.url.removeMeetingwithAgenda + '?agendaIdEncr=' + agendaIdEncr)
  }

  // Send Section Head Review
  sendSHRefinement(agendaId: any, obj: any) {
    return this.http.update(this.url.shRefinement + '?agendaId=' + agendaId + '&userId=' + JSON.parse(sessionStorage.getItem('userInfo-usec'))['userId'], obj);
  }

  AllCompletedMeetingHistoryRefinement(date: any) {
    if (sessionStorage.getItem('selectedRole-usec') === 'Executive Committee') {
      return this.http.get(this.url.meetingHistory + '?date=' + date);
    } else {
      return this.http.get(this.url.AllCompletedMeetingHistoryRefinement + '?sectionHeadUserId=' +
        JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&date=' + date);
    }
  }

  getAgendaListBySectionIdRefinement(meetingId: any, page: number, rowId: number) {
    return this.http.get(this.url.getAgendaListBySectionIdRefinement + '?sectionHeadUserId=' +
      JSON.parse(sessionStorage.getItem('userInfo-usec')).userId + '&meetingId=' + meetingId + '&sectionId=' + JSON.parse(sessionStorage.getItem('userInfo-usec')).section.sectionId + '&page=' + page + '&rows=' + rowId);
  }

  // Exists Refinement
  existsRefinement(agendaId: any) {
    return this.http.get(this.url.getAgendaExistsRefinement + '?agendaId=' + agendaId);
  }

  // Exists Refinement
  getRefinementComment(agendaId: any) {
    return this.http.get(this.url.getRefinementComment + '?agendaId=' + agendaId);
  }

  // Exists Refinement
  agendaRefinementStatus(agendaId: any) {
    return this.http.get(this.url.agendaRefinementStatus + '?agendaId=' + agendaId);
  }

  // Exists Refinement
  checkRefinement(meetingId: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.checkRefinement + '?meetingIdEncr=' + meetingIdEncr);
  }

  //add by gokul for AddNextmeetingDate
  addNextmeetingDate(sessionmeetingId: any, nextmeetingDateId: any) {
    return this.http.get(this.url.addNextmeetingDate + '?meetingId=' + sessionmeetingId + '&nextmeetingId=' + nextmeetingDateId);
  }

  // Agenda Ceated by gokul for Deferred to Next Meeting
  insertDeferredAgenda(deferredAgendaDTO: any) {
    return this.http.post(this.url.insertDeferredAgenda, deferredAgendaDTO)
  }
  secretaryReviewmeetingProcessHistory(meetingId: number) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.secretaryReviewmeetingProcessHistory + '?meetingIdEncr=' + meetingIdEncr);
  }

  // Preview pdf
  finalPreviewMOM(previousmeetingId: any, currentMeetingId) {
    return this.http.get(this.url.finalPreviewMOMPDF + '?previousmeetingId=' + previousmeetingId + '&currentMeetingId=' + currentMeetingId);
  }

  getmeetingdetailsById(meetingId: number) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getmeetingdetailsById + '?meetingIdEncr=' + meetingIdEncr);
  }

  finalpdfMomViewDocument(filePath: any) {
    return this.http.post(this.url.finalpdfMomViewDocument, filePath);
  }

  //esign service start
  getECMemberListForCurrentMeeting(meetingId: any) {
    const meetingIdEncr = encodeURIComponent(this.ced.encryptAesToString(meetingId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getECMemberListForCurrentMeeting + '?meetingIdEncr=' + meetingIdEncr);
  }

  getSecretaryUserDetailsList() {
    return this.http.get(this.url.getSecretaryUserDetailsList);
  }

  // signChangesReverted(meetingId: any,ecMemberId: any, userId: any) {
  //   return this.http.get(this.url.signChangesReverted + '?meetingId=' + meetingId + '&ecMemberId=' + ecMemberId + '&userId=' + userId);
  // }
  signChangesReverted(data: any) {
    return this.http.post(this.url.signChangesReverted, data);
  }

  getBaseStringMomFile(filePath: any) {
    return this.http.post(this.url.getBaseStringMomFile, filePath);
  }

  // CountOfReceiptsByStatus
  getUnsignedPdf(meetingId: any, userId: any) {
    return this.http.get(this.url.getUnsignedPdf + '?meetingId=' + meetingId + '&userId=' + userId);
  }

  signAndUploadMOM(obj: any) {
    return this.http.post(this.url.signAndUploadMOM, obj);
  }

  // UpdateECMemberAbsenteesName in ECMeetingSchedules
  updateECMemberAbsenteesName(meetingId: any, absenteesName: any) {
    return this.http.get(this.url.updateECMemberAbsenteesName + '?meetingId=' + meetingId + '&absenteesName=' + absenteesName);
  }

  executiveCommitteeMeetingReviewWithPagination(meetingSearchCriteria: any) {
    return this.http.post(this.url.executiveCommitteeMeetingReviewWithPagination, meetingSearchCriteria);
  }

  secretaryMeetingReviewWithPagination(meetingSearchCriteria: any) {
    return this.http.post(this.url.secretaryMeetingReviewWithPagination, meetingSearchCriteria);
  }

  presidentMeetingReviewWithPagination(meetingSearchCriteria: any) {
    return this.http.post(this.url.presidentMeetingReviewWithPagination, meetingSearchCriteria);
  }

  getAllAgendByMeetingIdOrderByItemRefnumberWithPagination(agendaSearchCriteria: any) {
    return this.http.post(this.url.getAllAgendByMeetingIdOrderByItemRefnumberWithPagination, agendaSearchCriteria);
  }

  getAOBAgendaItemNumber(obj: any) {
    return this.http.post(this.url.getAOBAgendaItemNumber, obj);
  }

  getexportPdfMeetingWithPagination(meetingSearchCriteria: any) {
    return this.http.post(this.url.getexportPdfMeetingWithPagination, meetingSearchCriteria);
  }

  getexportPdfAgendaWithPagination(agendaSearchCriteria: any) {
    return this.http.post(this.url.getexportPdfAgendaWithPagination, agendaSearchCriteria);
  }

  getbulkAgendaExportPdf(exportPdfAgenda: any) {
    return this.http.post(this.url.getbulkAgendaExportPdf, exportPdfAgenda);
  }


  //Added by gokul for eccompletedmeetingview
  getECCompletedMeetingView(meetingId: any) {
    return this.http.get(this.url.getECCompletedMeetingView + '?meetingId=' + meetingId);
  }

  getfinalizeMeetingAttachmentFile(meetingId: any) {
    return this.http.get(this.url.getfinalizeMeetingAttachmentFile + '?meetingId=' + meetingId);
  }

  sendFinalizedMeetingAgendaViaEmail(finalizedMeetingAgenda: any) {
    return this.http.post(this.url.sendFinalizedMeetingAgendaViaEmail, finalizedMeetingAgenda);
  }

  getAllMeetingListWithPagination(meetingSearchCriteria: any) {
    return this.http.post(this.url.getAllMeetingListWithPagination, meetingSearchCriteria);
  }

  getEcAgendaSectionListDashboardList() {
    return this.http.get(this.url.getEcAgendaSectionListDashboardList);
  }
  getMeetingSectionListBasedAgendaItems(meetingId: any) {
    return this.http.get(this.url.getMeetingSectionListBasedAgendaItems + '?meetingId=' + meetingId);
  }


  getECAgendaViewDetailsById(agendaId: any) {
    const agendaIdEncr = encodeURIComponent(this.ced.encryptAesToString(agendaId, this.serverURL.secretKey).toString());
    return this.http.get(this.url.getECAgendaViewDetailsById + '?agendaIdEncr=' + agendaIdEncr)
  }

  ecMeetingAgendaSendForReview(obj: any) {
    return this.http.post(this.url.ecMeetingAgendaSendForReview, obj);
  }
  ecMeetingAgendaReturnForCorrection(obj: any) {
    return this.http.post(this.url.ecMeetingAgendaReturnForCorrection, obj);
  }


  fileUploadECMeetingCreateAgenda(filearray: any, agendaId: any) {
    const formdata: FormData = new FormData();
    for (let i = 0; i < filearray.length; i++) {
      formdata.append('files', filearray[i]);
    }
    formdata.append('agendaId', JSON.stringify(agendaId));
    return this.http.post(this.url.fileUploadECMeetingCreateAgenda, formdata);
  }

  deleteECMeetingCreateAgendaDocument(obj: any) {
    return this.http.post(this.url.deleteECMeetingCreateAgendaDocument, obj);
  }

  trackAgendaWithPagination(agendaSearchCriteria: any) {
    return this.http.post(this.url.trackAgendaWithPagination, agendaSearchCriteria);
  }

  trackMinutesWithPagination(agendaSearchCriteria: any) {
    return this.http.post(this.url.trackMinutesWithPagination, agendaSearchCriteria);
  }
}

